import { useState, useRef, useCallback, useEffect } from 'react'
import { getProducts } from '../lib/apiService';

export default function useProductSearch(selectedCategories) {
    const [products, setProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const observer = useRef()
    const lastElementRef = useCallback(node => {
        if (loading) return
        if (observer.current) observer.current.disconnect()
            observer.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && hasMore) {
            setPageNumber(prevPageNumber => prevPageNumber + 1)
        }
        })
        if (node) observer.current.observe(node)
    }, [loading, hasMore]);

    useEffect(() => {
        setProducts([]);
        setPageNumber(1);
    }, [selectedCategories, searchTerm]);

    useEffect(() => {
        const fetchProducts = async () => {
          setLoading(true);
          setError(null);
          const { products, hasMore } = await getProducts({
            searchTerm,
            selectedCategories,
            page: pageNumber
          });
          setHasMore(hasMore);
          setProducts(prevProducts => [...prevProducts, ...products]);
          setLoading(false);
          setError(null);
        };
        fetchProducts();
      }, [selectedCategories, searchTerm, pageNumber]);
  
      const handleProductSearchTermOnKeyUp = async (e) => {
        if (e.key === 'Enter') {
          const { products } = await getProducts({
            searchTerm,
            selectedCategories,
            page: pageNumber
          })
          setProducts(products);
        }
      };
    
      const handleProductSearchIconClick = async () => {
        const { products } = await getProducts({
          searchTerm,
          selectedCategories,
          page: pageNumber
        });
        setProducts(products);
      };
    const handleOnProductSearchTermChange = (e) => {
        setSearchTerm(e.target.value);
        setPageNumber(1);
      };

  return {
    productSearchTerm: searchTerm,
    productsLoading: loading,
    productsError: error,
    productsPageNumber: pageNumber,
    productsLastElementRef: lastElementRef,
    filteredProducts: products,
    handleProductSearchTermOnKeyUp,
    handleProductSearchIconClick,
    handleOnProductSearchTermChange
  };
}
